module.exports = __webpack_public_path__ + "static/media/emmett.449e8970.png";